/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {getVenueSession} from "../../requests/AppSession";
import {NumericFormat} from "react-number-format";
import {findVenueBuyPackages} from "../requests/AppRequestPackages";
import {useAuth} from "@workos-inc/authkit-react";
import {TierGridSkeleton} from "./VTSkeletons";

export default function VTBuy() {
    let navigate = useNavigate();

    const {isLoading, getAccessToken} = useAuth();

    const [tiers, setTiers] = useState(null);

    const [venueId, setVenueId] = React.useState(null);
    const [venueName, setVenueName] = React.useState(null);
    const [vt, setVT] = React.useState(null);

    const [errorMessage, setErrorMessage] = React.useState(null);

    useEffect(() => {
        getVenueSession().then(venueSession => {
            if (venueSession && venueSession.id !== "null") {
                setVenueId(venueSession.venueId);
                setVenueName(venueSession.venueName);
            } else {
                navigate('/login/mobile', {replace: true});
            }
        })
        return function cleanup() {

        };
    }, []);

    const getSuccess = async responseJson => {
        if (
            responseJson
        ) {
            setTiers(responseJson.packagesVTList);
            setVT(responseJson.userVirtualTipz);
        } else {
            setErrorMessage("Error accessing venue packages, please refresh and verify Internet Connection.");
        }
    };

    const getError = forceLogout => {
        setErrorMessage("Error accessing venue packages, please refresh and verify Internet Connection.");
    };

    useEffect(() => {
        if (!isLoading && venueId !== null) {
            findVenueBuyPackages(venueId, getSuccess, getError, getAccessToken);
        }
        return function cleanup() {

        };
    }, [isLoading, venueId]);

    return (
        <div className="bg-white dark:bg-gray-900">

            {/* Pricing with four tiers and toggle */}
            <div className="bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800">
                <div className="mx-auto max-w-7xl px-4 pt-12 sm:px-6 lg:px-8">
                    <div className="sm:align-center sm:flex sm:flex-col">
                        <h1 className="text-5xl font-bold tracking-tight text-gray-900 dark:text-gray-100 text-center">Buy Virtual<span
                            className="text-pink-400">Tipz</span></h1>
                        {vt != null && <p className="mt-4 text-center">
                                    <span
                                        className="inline-flex items-center rounded-md bg-pink-50 dark:bg-pink-950/40 px-2 py-1 text-sm font-bold text-gray-900 dark:text-pink-200 ring-1 ring-inset ring-pink-700/10 dark:ring-pink-800">
                                        You have &nbsp; {<NumericFormat value={vt} displayType={'text'}
                                                                        thousandSeparator={true}/>} &nbsp; VirtualTipz
                                    </span>
                        </p>}

                        {!tiers && <TierGridSkeleton/>}
                    </div>
                    <div
                        className="mt-12 space-y-4 sm:mt-16 sm:grid sm:grid-cols-2 sm:gap-6 sm:space-y-0 lg:mx-auto lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4">
                        {tiers?.map((tier) => (
                            <div key={tier.id}
                                 className="divide-y divide-gray-200 dark:divide-gray-700 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
                                <div className="p-6">
                                    <h2 className="text-lg font-medium leading-6 text-gray-900 dark:text-gray-100">{tier.name} ({tier.virtualTips} VirtualTipz)</h2>
                                    <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">{tier.description}</p>
                                    <p className="mt-8">
                                        <span
                                            className="text-4xl font-bold tracking-tight text-gray-900 dark:text-gray-100">${tier.price}</span>{' '}
                                    </p>
                                    <span
                                        className="mt-8 block w-full rounded-md border border-transparent bg-gray-400 py-2 text-center text-sm font-semibold text-white"
                                    >
                                        Go to the Front Desk to Buy {tier.name}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
